module.exports = __webpack_public_path__ + "assets/shape-footer-corner.33fb8602.svg";